// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__-mcBm","description":"styles_description__N1YvQ","description_item":"styles_description_item__qJZeH","spinner":"styles_spinner__SXmAS"};